export default __webpack_public_path__ + "static/media/remove-file.7dcf1db9.svg";